import classnames from 'classnames';
import * as React from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../../../modules';
import { Market, selectMarkets } from '../../../../modules/public/markets';
import { DEFAULT_GROUP, GROUP_LIST } from '../../../../stock_config/stock-ui-config';
interface ReduxProps {
    markets: Market[];
}

interface OwnProps {
    onSelect?: (value: string) => void;
}

interface State {
    selectedItem: string;
    scrollLeft: number;
}

type Props = ReduxProps & OwnProps;

export class MarketsTabsComponent extends React.Component<Props, State> {
    public readonly state = {
        selectedItem: DEFAULT_GROUP,
        scrollLeft: 0,
    };

    public constructor(props: any) {
        super(props);
        // this.tabsRef = React.createRef();
    }

    // private tabsRef;

    public render() {
        return this.fastSearchButtons();
    }

    private fastSearchButtons = () => {
        let listOfQuote: string[] = GROUP_LIST;
        // const validMarkets = this..filter(market => market && market.id)
        return (
            <div
                className="pg-trading-header-fast-search-container"
                onWheel={this.handleOnMouseWheel}
                // ref={this.tabsRef}
            >
                {listOfQuote.map(this.renderFastSearchButton)}
            </div>
        );
    };

    private renderFastSearchButton = (item: string, index: number) => {
        const classname = classnames('pg-trading-header-fast-search-button', {
            'pg-trading-header-fast-search-button-active': this.state.selectedItem === item,
        });

        return (
            <div className={classname} key={index} onClick={() => this.handleSelectButton(item)}>
                {item}
            </div>
        );
    };

    private handleOnMouseWheel = (event: React.WheelEvent) => {
        // this.tabsRef.current.scrollLeft += event.deltaX;
    };

    private handleSelectButton = (item: string) => {
        this.setState({
            selectedItem: item,
        });
        this.props?.onSelect?.(item);
    };
}

const mapStateToProps = (state: RootState): ReduxProps => ({
    markets: selectMarkets(state),
});

//tslint:disable-next-line:no-any
export const MarketsTabs = connect(mapStateToProps, {})(MarketsTabsComponent) as any;
